import clsx from 'clsx';
import React from 'react';

import s from './shared.module.less';

export const Container: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...rest }) => (
  <div {...rest} className={clsx(s.container, className)}>
    {children}
  </div>
);
